import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { SweetMessage } from '../../../config/sweet-message';
import { CuentaContable } from '../../../models/cuenta-contable';
import { TipoCuenta } from '../../../models/tipo-cuenta';
import { CuentaContableService } from '../../../services/cuenta-contable.service';
import { TipoCuentaService } from '../../../services/tipo-cuenta.service';

@Component({
  selector: 'app-plan-cuentas-edit-modal',
  templateUrl: './plan-cuentas-edit-modal.component.html',
  styleUrls: ['./plan-cuentas-edit-modal.component.css'],
  providers: [
    CuentaContableService,
    TipoCuentaService,
  
  ],
})
export class PlanCuentasEditModalComponent implements OnInit {
  @Input() cuenta_contable_id: number;
  @Input() cuentaPadre: CuentaContable;
  @Output() sendCuenta = new EventEmitter();
  public cuentaContable: CuentaContable;
  public tipoCuenta: TipoCuenta;
  public loading: boolean;
  public msgSweet: SweetMessage;
  public estados: Array<String>;
  constructor(
    public bsModalRef: BsModalRef,
    private cuentaContableService: CuentaContableService,
    private tipoCuentaService: TipoCuentaService,
  ) { 
    this.cuentaContable = new CuentaContable();
    this.tipoCuenta = new TipoCuenta();
    this.loading = false;
    this.msgSweet = new SweetMessage();
    this.estados = ['A', 'E'];
  }

  ngOnInit() {
    this.loading = true;
    this.getCuentaContableById().then(
      res => {
        this.getTipoCuentaById().then(
          res => this.loading = false,
          err => this.loading = false,
        )
      },
      err => this.loading = false,
    )
  }

  isValid(){
    if(this.cuentaContable.nombre == ""){
      return false;
    }
    return true;
  }

  getCuentaContableById(){
    return new Promise ((resolve, reject) => {
      this.cuentaContableService.getById(this.cuenta_contable_id).subscribe(
        res =>{
          this.cuentaContable = res;
          resolve();
        },
        err => {
          reject();
        }
      )
    });
    
  }

  getTipoCuentaById(){
    return new Promise( (resolve, reject) => {
      this.tipoCuentaService.getById(this.cuentaContable.tipo_cuenta_id).subscribe(
        res =>{
          this.tipoCuenta = res;
          resolve();
        },
        err => {
          reject();
        }
      )
    });
    
  }



  setValueEntity(){
    this.cuentaContable.nombre = this.cuentaContable.nombre.trim();
    this.cuentaContable.descripcion = this.cuentaContable.descripcion?this.cuentaContable.descripcion.trim():'';
  }

  onSubmit(){
    this.setValueEntity();
		this.loading = true;
		this.cuentaContableService.update(this.cuentaContable).subscribe(
			res => {
				this.msgSweet.showMessage('success-message', res.message);  
        this.sendCuenta.emit(res.data);
        this.loading = false;
			},
			err => {
        this.loading = false;
        this.cuentaContable = new CuentaContable();
        this.msgSweet.showMessage('error-message',err);
			}
		);
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/plan-cuentas-edit-modal/plan-cuentas-edit-modal.component.ts